import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { userService } from '../services/apiUserService'

export const createAPIUser = createAsyncThunk('user/create', async (data, { rejectWithValue }) => {
  try {
    const response = await userService.createAPIUser(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const getAllAPIUsers = createAsyncThunk('user/getAll', async (_, { rejectWithValue }) => {
  try {
    const response = await userService.getAll()
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const getOneAPIUser = createAsyncThunk('user/getOne', async (data, { rejectWithValue }) => {
  try {
    const response = await userService.getOne(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

const initialState = {
  data: [],
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllAPIUsers.pending]: (state) => {
      if (state.data.length <= 0) {
        state.loading = true
      }
    },
    [getAllAPIUsers.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllAPIUsers.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneAPIUser.pending]: (state) => {
      state.loading = true
    },
    [getOneAPIUser.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneAPIUser.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [createAPIUser.pending]: (state) => {
      state.loading = true
    },
    [createAPIUser.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [createAPIUser.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
